import { fillPlot, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { MA_TYPE, PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { fillMovingAverage } from "../math/movingAverages";
import { fillAverageTrueRange } from "../math/trueRange";

/**
 * Keltner Channel (research §1.4): EMA of the close ± multiplier × the
 * classic ATR (Wilder / RMA) of its own period, as PO has a separate ATR
 * input. Only the middle line matches TV Keltner Channels: TV takes the
 * EMA of the true range with the EMA length.
 */
export default {
  id: "keltner-channel",
  name: "Keltner Channel",
  isOscillator: false,
  inputs: [
    periodInput("emaPeriod", "EMA", 20, { max: 100 }),
    periodInput("atrPeriod", "ATR", 10, { max: 100 }),
    periodInput("multiplier", "Multiplier", 1, { max: 5 }),
  ],
  plots: [
    linePlot("top", "Top", PALETTE.LIME),
    linePlot("middle", "Middle", PALETTE.AQUA),
    linePlot("bottom", "Bottom", PALETTE.YELLOW),
    fillPlot("background", "Background", PALETTE.LIME, ["top", "bottom"]),
  ],
  buffers: ["atr"],
  levels: [],

  calculate: (bars, { emaPeriod, atrPeriod, multiplier }, series, fromIndex) => {
    fillMovingAverage({
      type: MA_TYPE.EMA,
      read: priceReader(bars, PRICE_SOURCE.CLOSE),
      target: series.middle,
      period: emaPeriod,
      fromIndex,
      toIndex: bars.length,
    });
    fillAverageTrueRange({ bars, target: series.atr, period: atrPeriod, fromIndex });

    for (let index = fromIndex; index < bars.length; index += 1) {
      series.top[index] = series.middle[index] + multiplier * series.atr[index];
      series.bottom[index] = series.middle[index] - multiplier * series.atr[index];
    }
  },
};
